import { useLottie } from 'lottie-react';
import successJson from '../assets/lottie/success.json';
import loadingJson from '../assets/lottie/loading.json';
import emptyJson from '../assets/lottie/empty.json';

const ANIM_MAP = {
  success: successJson,
  loading: loadingJson,
  empty: emptyJson,
};

const DEFAULT_LOOP = {
  success: false,
  loading: true,
  empty: true,
};

export default function LottieAnim({ type, size = 120, loop, className = '' }) {
  const animData = ANIM_MAP[type];
  const shouldLoop = loop !== undefined ? loop : DEFAULT_LOOP[type] ?? false;

  const { View } = useLottie({
    animationData: animData || loadingJson,
    loop: shouldLoop,
    style: { width: size, height: size },
  });

  if (!animData) return null;

  return <div className={className}>{View}</div>;
}
